<template>
  <div></div>
</template>

<script>
import { mapActions } from 'vuex'
import ApiService from '@/services/ApiService'
import { Base64 } from 'js-base64';
import rollbar from 'rollbar';

global.atob = require('atob')

export default {
  name: 'OidcCallback',
  methods: {
    ...mapActions(['oidcSignInCallback'])
  },
  mounted() {
    this.oidcSignInCallback()
      .then(redirectPath => {
        ApiService.setAccessToken(this.$store.getters['oidcAccessToken']).then(
          () => {
            ApiService.getRolesForUser(
              this.$store.getters['oidcUser'].sub
            ).then(response => {
              this.$store.commit('user/roles', response.data)
              this.$router.push(redirectPath)
            })
          }
        )
        if (process.env.VUE_APP_DEBUGMODE) {
          rollbar.debug('TOKEN:' + this.$store.getters['oidcAccessToken']);
        }
        const parts = this.$store.getters['oidcAccessToken'].split('.')
        if (parts.length > 1) {
          const tokendata = JSON.parse(Base64.decode(parts[1]))
          this.$store.commit('ui/setLocale', tokendata.locale)
        }

      })
      .catch(err => {
        console.error(err)
        this.$router.push('/oidc-callback-error') // Handle errors any way you want
      })
  }
}
</script>

<style scoped></style>
